// Sales log helpers: entries recorded during the month and turned into invoice lines.

import { num, uid } from "./utils";

export const saleAmount = (x) => Math.round(num(x.qty || 1) * num(x.rate) * 100) / 100;

export function unbilledSales(sales, { clientId, upto } = {}) {
  return (sales || [])
    .filter((x) => !x.invoiceId && (!clientId || x.clientId === clientId) && (!upto || (x.date || "") <= upto))
    .sort((a, b) => (a.date || "").localeCompare(b.date || ""));
}

export function saleToLine(x, projects = [], defaultTaxRate = 18) {
  const p = projects.find((pr) => pr.id === x.projectId);
  return {
    id: uid(),
    saleId: x.id,
    projectId: x.projectId || "",
    description: x.description || "",
    hsn: p?.hsn || "",
    qty: num(x.qty) || 1,
    rate: num(x.rate),
    taxRate: x.taxRate !== undefined && x.taxRate !== "" ? num(x.taxRate) : p ? num(p.taxRate) : defaultTaxRate,
    tag: x.tag || p?.tag || "",
  };
}
